// extracted by mini-css-extract-plugin
export default {"img":"classes_img__POufd","pin":"classes_pin__b6NiW"};